module.exports = __webpack_public_path__ + "2a309e40548c6a3ef85316e02ebd94c8.png";